"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileBlockSolid: function() {
        return FileBlockSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileBlockSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M10 15C10 13.8954 10.8954 13 12 13C12.168 13 12.3312 13.0207 12.4871 13.0597L10.0609 15.4917C10.0211 15.3344 10 15.1697 10 15Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.456 16.9251L13.9238 14.4514C13.9734 14.6257 14 14.8097 14 15C14 16.1046 13.1046 17 12 17C11.8114 17 11.6289 16.9739 11.456 16.9251Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 1C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V8C21 7.73478 20.8946 7.48043 20.7071 7.29289L14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1H6ZM14.7909 12.1345C14.0702 11.4325 13.0856 11 12 11C9.79086 11 8 12.7909 8 15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15C16 13.8864 15.5449 12.8791 14.8106 12.1538L14.807 12.1502L14.7909 12.1345ZM18.5 8L14 3.5V7C14 7.55228 14.4477 8 15 8H18.5Z",
            fill: "currentColor"
        })
    ]
}), "FileBlockSolid");
const _default = FileBlockSolid;
